import { DisciplineChipButton } from './DisciplineChipButton';

export function DisciplineSelector({
	selectedDisciplineId,
	setSelectedDisciplineId,
	disciplineOptions
}: {
	selectedDisciplineId: number;
	setSelectedDisciplineId: (disciplineId: number) => void;
	disciplineOptions: { id: number; abbreviation: string }[];
}) {
	return (
		<div className="flex items-center gap-1.5">
			{disciplineOptions.map(d => {
				return (
					<DisciplineChipButton
						key={d.id}
						id={d.id}
						abbreviation={d.abbreviation}
						selected={selectedDisciplineId === d.id}
						onClick={() => setSelectedDisciplineId(d.id)}
					/>
				);
			})}
		</div>
	);
}
